import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Signal } from '@angular/core';
import { ButtonModule, SelectModule, InputModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FinanceReviewForm, FinanceReviewFormGroup } from '../../../models/cod-review.model';
import { CodReviewOperations } from '../../../operations/cod-review.operations';
import { CodReviewState } from '../../../state/cod-review.state';
import { select, Store } from '@ngxs/store';
import { SubmitFinanceReview } from '../../../state/cod-review.action';
import { ReviewResult, BasicReviewResult, ReviewNextStepClose } from '@cod-monorepo/interfaces';
import { CodReviewSuccessComponent } from '../review-success/review-success.component';
import { NgxsFormDirective } from '@ngxs/form-plugin';

@Component({
    selector: 'app-cod-finance-review-step',
    templateUrl: './finance-review.component.html',
    imports: [
        CommonModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        InputModule,
        ButtonModule,
        TextareaModule,
        CodReviewSuccessComponent,
        NgxsFormDirective
    ],
    standalone: true
})
export class CodFinanceReviewStepComponent implements OnInit, OnChanges {
    @Input() disabled: boolean;

    protected submitting: Signal<boolean> = select(CodReviewState.submittingFinanceReview);
    protected submittingSuccess: Signal<boolean> = select(CodReviewState.submittingFinanceReviewSuccess);
    public formGroup: FormGroup<FinanceReviewFormGroup>;
    public basicReviewResult = BasicReviewResult;
    public reviewResult = ReviewResult;
    public nextSteps = ReviewNextStepClose;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.formGroup = CodReviewOperations.initializeFinanceReviewForm();

        if (this.disabled) {
            this.formGroup.disable();
        }
    }

    public ngOnChanges(): void {
        if (this.disabled) {
            this.formGroup && this.formGroup.disable();
        } else {
            this.formGroup && this.formGroup.enable();
        }
    }

    public submit(): void {
        if (this.formGroup.invalid) {
            return;
        }

        this.store.dispatch(new SubmitFinanceReview(this.formGroup.value as FinanceReviewForm));
        this.formGroup.disable();
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }
}
